import React, { useState } from 'react'

import { faCheck, faCopy } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Paper, Typography } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { makeStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import useScid from 'common/use-scid'
import PreviewApplicationButton from 'routes/application/Activate/components/PreviewApplicationButton'
import { useAppCycle } from 'store/application-cycle/hooks'

import FadeWrapper from './Fader'
import ApplyWithScoirImage from './apply-with-scoir.png'

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(2),
  },
  header: {
    marginBottom: theme.spacing(2),
  },
  applyWithScoirImage: {
    maxHeight: 318,
    maxWidth: 318,
    height: '100%',
    width: '100%',
  },
  button: {
    overflowWrap: 'anywhere',
    maxWidth: 'fit-content',
  },
}))

const Activated = ({ configurationId, applicationCycle }) => {
  const styles = useStyles()

  const theme = useTheme()
  const isSmallScreenSize = useMediaQuery(theme.breakpoints.down('sm'))

  const scid = useScid()
  const applicationUrl = `${window.location.hostname}/app/signup/${scid}`
  const [copied, setCopied] = useState(false)
  const currentAppRound = useAppCycle()
  const isForNextYear = applicationCycle !== currentAppRound

  return (
    <Paper className={styles.container}>
      <Box
        display="flex"
        flexWrap={isSmallScreenSize ? 'wrap' : 'nowrap'}
        gridGap={40}
        p={3}
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          flexGrow={1}
        >
          <Typography
            variant="h5"
            component="p"
            className={styles.header}
          >
            {`Your ${applicationCycle - 1}-${applicationCycle} Application is ${
              isForNextYear ? `ready to go live August 1st, ${applicationCycle - 1}` : 'Live!'
            }`}
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
          >
            Press the button below for your <strong>unique URL to your application</strong>. Clicking this will copy the
            link to your clipboard.
          </Typography>
          <Box
            display="flex"
            flexWrap="wrap"
            flexDirection="row"
            gridGap={8}
            alignItems="center"
            mt={2}
          >
            <Button
              variant="outlined"
              color="primary"
              className={styles.button}
              onClick={() => {
                navigator.clipboard.writeText(applicationUrl)
                if (!copied) {
                  setCopied(true)
                } else {
                  setCopied(false)
                  setTimeout(() => setCopied(true), 250)
                }
              }}
              startIcon={
                <FontAwesomeIcon
                  size="xs"
                  icon={faCopy}
                />
              }
            >
              Copy link to your clipboard
            </Button>
            <PreviewApplicationButton
              configurationId={configurationId}
              variant="contained"
            />
          </Box>

          <FadeWrapper
            expanded={copied}
            timeout={500}
          >
            <Box mt={2}>
              <Typography
                variant="body2"
                color="textSecondary"
              >
                <FontAwesomeIcon icon={faCheck} />
                &nbsp; Link copied to clipboard!
              </Typography>
            </Box>
          </FadeWrapper>
        </Box>
        <img
          src={ApplyWithScoirImage}
          className={styles.applyWithScoirImage}
          alt="Apply with Scoir"
        />
      </Box>
    </Paper>
  )
}

export default Activated
